<template>
  <div>
    <div class="row">
      <div class="col-12">
        <ReportFilterPopover
          class="float-right mr-2"
          headerTitle="On Hand Filter"
          :showApplyButton="true"
          :showResetButton="true"
          @apply="applySummaryFilter"
          @reset="resetSummaryFilter">
          <template v-slot:popover>
            <ReportFilterGroup label="Account Location">
              <AccountLocationMultiSelect v-model="editingAccountLocationIdList" />
            </ReportFilterGroup>
          </template>
          <template v-slot:filterDisplay>
            <ReportFilterDisplayAccountLocation :accountLocationId="accountLocationId" />            
          </template>
        </ReportFilterPopover>

        <ContentTitle>{{title}}</ContentTitle>
        <ContentSubTitle>Based on current inventory values</ContentSubTitle>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <StaticDataTable class="static-table-list" :striped="true">
          <template v-slot:header>
            <tr>
              <th>Name</th>
              <th>{{dataTitle}}</th>
            </tr>
          </template>
          <template v-slot:body>
            <template v-for="(valueInfo, index) in valueList">
              <tr :key="`stock-info-${index}`">
                <td class="font-weight-bold">
                  <LinkStock v-if="valueInfo.stockId" :name="valueInfo.name" :id="valueInfo.stockId" />
                  <LinkContact v-else-if="valueInfo.contactId" :name="valueInfo.name" :id="valueInfo.contactId" />
                  <span v-else>{{valueInfo.name}}</span>
                </td>
                <td>
                  <span v-html="valueInfo.displayValue"></span>
                </td>
              </tr>
            </template>
          </template>
          <template v-slot:empty v-if="valueList.length == 0">
            No data found
          </template>
        </StaticDataTable>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportFilterGroup from '@/components/reporting/reportFilterGroup'
import AccountLocationMultiSelect from '@/modules/admin/components/accountLocationMultiSelect'
import ReportFilterDisplayAccountLocation from '@/components/reporting/reportFilterDisplayAccountLocation'

export default {
  name: 'InventoryValueSummaryList',
  components: {
    ReportFilterPopover,
    ReportFilterGroup,
    AccountLocationMultiSelect,
    ReportFilterDisplayAccountLocation
  },
  props: {
    title: String,
    dataTitle: String,
    valueList: Array,
    accountLocationId: [Array, Number],
  },
  watch: {
    accountLocationId: function() {
      this.editingAccountLocationIdList = this.accountLocationId || []
    }
  },
  data() {
    return {
      editingAccountLocationIdList: this.accountLocationId || []
    }
  },
  methods: {
    applySummaryFilter() {
      this.$emit('applyFilter', { accountLocationId: this.editingAccountLocationIdList })
    },
    resetSummaryFilter() {
      this.$emit('resetFilter')
    },
  }
}
</script>